import React from "react"

import EmbedVimeo from "@atoms/EmbedVimeo/EmbedVimeo"
import EmbedYoutube from "@atoms/EmbedYoutube/EmbedYoutube"
import VideoJwPlayer from "@atoms/VideoJWPlayer/VideoJWPlayer"

import styles from "./CoreEmbed.module.scss"

const CoreEmbed = ({
  captionText,
  providerNameSlug,
  type,
  url,
  jwPlayerID,
}) => {
  let embed = null

  if (type === "video") {
    switch (providerNameSlug) {
      case "youtube":
        embed = <EmbedYoutube url={url} caption={captionText} />
        break
      case "vimeo":
        embed = <EmbedVimeo url={url} caption={captionText} />
        break
      case "jwplayer":
        embed = <VideoJwPlayer id={jwPlayerID} />
        break
      default:
    }
  }

  const wrappedEmbed = captionText ? (
    <figure>
      {embed}
      <figcaption>{captionText}</figcaption>
    </figure>
  ) : (
    embed
  )

  return embed ? (
    <section className={styles.element}>{wrappedEmbed}</section>
  ) : null
}

export default CoreEmbed
